import React from 'react';
import { HeroSection } from './components/Hero';
import { StorySection } from './components/Story';
import { ProblemSection } from './components/Problem';
import { FailedSolutionsSection } from './components/FailedSolutions';
import { SolutionSection } from './components/Solution';
import { ChaptersSection } from './components/Chapters';
import { BonusesSection } from './components/Bonuses';
import { TestimonialsSection } from './components/Testimonials';
import { AudienceSection } from './components/Audience';
import { PricingSection } from './components/Pricing';
import { GuaranteeSection } from './components/Guarantee';
import { CTASection, FinalMessageSection, FAQSection, FooterSection } from './components/FinalSections';
export function App() {
  return <div className="min-h-screen bg-cream-100 font-sans text-gray-800" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StorySection data-id="element-2" />
      <div className="flex justify-center py-3 sm:py-8 px-4 sm:px-6 bg-white" data-id="element-3">
        <a href="https://mujercashflow.com/cart/46676096385214:1" className="block w-full max-w-xs text-center bg-rose-500 hover:bg-rose-600 text-white font-medium py-3 sm:py-4 px-5 sm:px-6 rounded-full shadow-lg transition-all text-sm sm:text-base" data-id="element-4">
          QUIERO MI COPIA AHORA
        </a>
      </div>
      <ProblemSection data-id="element-5" />
      <FailedSolutionsSection data-id="element-6" />
      <SolutionSection data-id="element-7" />
      <ChaptersSection data-id="element-8" />
      <BonusesSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <AudienceSection data-id="element-11" />
      <PricingSection data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <CTASection data-id="element-14" />
      <FinalMessageSection data-id="element-15" />
      <FAQSection data-id="element-16" />
      <FooterSection data-id="element-17" />
    </div>;
}